import React from 'react';
import KpiStrip from './KpiStrip';

export default function DashboardTodayStats({ items, ariaLabel }) {
  const normalizedItems = items.map((item) => ({
    ...item,
    unitInline: Boolean(item.unit),
  }));

  return (
    <KpiStrip
      items={normalizedItems}
      variant="today-grid"
      className="dashboard-today-stats"
      ariaLabel={ariaLabel}
    />
  );
}